import React from 'react';

interface BadgeProps {
  className?: string;
}

const GooglePlayBadge: React.FC<BadgeProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 170 50" 
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background - Increased width for padding */}
      <rect width="170" height="50" rx="10" fill="white" />
      
      <g transform="translate(18, 9)">
        {/* Google Play Logo */}
        <path
          d="M2.5 2.5 L2.5 29.5 L16 16 L2.5 2.5 Z"
          fill="#00D4FF" // Blue
        />
        <path
          d="M16 16 L2.5 29.5 L20 20 L16 16 Z"
          fill="#FF3A44" // Red
        />
        <path
          d="M16 16 L20 12 L2.5 2.5 L16 16 Z"
          fill="#00E277" // Green
        />
        <path
          d="M16 16 L20 12 L25 16 L20 20 L16 16 Z"
          fill="#FFC107" // Yellow
        />
        
        {/* Text Group */}
        <g transform="translate(35, 2)">
          <text x="0" y="8" fill="black" fontSize="9" fontFamily="sans-serif" fontWeight="500">GET IT ON</text>
          <text x="0" y="24" fill="black" fontSize="19" fontFamily="sans-serif" fontWeight="bold">Google Play</text>
        </g>
      </g>
    </svg>
  );
};

export default GooglePlayBadge;
